import * as React from 'react';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import PaymethodDailyLimitsTable from '../stats/PaymethodDailyLimitsTable';
import MerchantPaymentsAccessTable from '../merchants/MerchantPaymentsAccessTable';

export default function LimitsIndex() {
    const [filters] = React.useState({
        from: moment.utc().startOf('day').toISOString(),
        to: moment.utc().endOf('day').toISOString(),
    });

    return (
        <React.Fragment>
            <Grid size={12}>
                <PageHeader
                    title="Limits"
                    subtitle="Paymethod caps and merchant payment access / daily volume"
                    breadcrumbs={[['Dashboard', '/'], ['Limits', '/limits']]}
                />
            </Grid>
            <Grid size={12}>
                <SectionCard sx={{ overflowX: 'auto', p: 2 }}>
                    <MerchantPaymentsAccessTable />
                </SectionCard>
            </Grid>
            <Grid size={12}>
                <SectionCard sx={{ overflowX: 'auto', p: 2 }}>
                    <PaymethodDailyLimitsTable filters={filters} />
                </SectionCard>
            </Grid>
        </React.Fragment>
    );
}
